import { useEffect, useState } from "react";
import { getPartner } from "./partner";
import useAppContext from "./useAppContext";

const useCobranding = () => {
  const searchParams = new URLSearchParams(location.search);
  const partnerId = searchParams.get("partner-id");
  const { dispatch } = useAppContext();
  const [isLoading, setIsLoading] = useState(Boolean(partnerId));

  useEffect(() => {
    if (!partnerId) {
      return;
    }

    const load = async () => {
      const partner = await getPartner(partnerId);

      if (partner) {
        const style = document.createElement("style");
        style.innerHTML = partner.themeCss;
        document.head.appendChild(style);
        dispatch({ type: "SET_PARTNER", partner });
      }

      setIsLoading(false);
    };

    load();
  }, [partnerId, dispatch]);

  return { isLoading };
};

export default useCobranding;
